/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Destination configuration for BigQuery dataset restore.
*/
export class BigQueryDatasetDestination {
  /**
  * Target dataset ID for the restore. If the dataset doesn\'t exist, it will be created. 
  */
  'datasetId': string;
  /**
  * BigQuery location for the dataset (e.g., \"US\", \"EU\", \"us-central1\"). Defaults to the original dataset location if not specified. 
  */
  'location'?: string;
  /**
  * List of table names to restore. If empty or not specified, all tables in the snapshot will be restored. 
  */
  'selectedTables'?: Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "datasetId",
      "baseName": "datasetId",
      "type": "string",
      "format": ""
    },
    {
      "name": "location",
      "baseName": "location",
      "type": "string",
      "format": ""
    },
    {
      "name": "selectedTables",
      "baseName": "selectedTables",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BigQueryDatasetDestination.attributeTypeMap;
  }

  public constructor() {
  }
}

